import {type PrizeWinner} from 'api/types';
import type {PartValueRenderer} from 'schema/types';
import {useLocalization} from 'localization';
import {isNullish} from 'schemaDefinition';
import {useCodelist} from 'services/codelists';
import {Builder} from 'services/utils';
import {FlexBox} from 'components';
import {PreviewLinkedEntity} from 'schema/preview/components/PreviewLinkedEntity';
import {useTextValue} from 'schema/preview/hooks';
import {CodeListRef} from 'schemas/references';

export const PrizeWinners: PartValueRenderer = ({value}) => {
  const {t} = useLocalization();
  const TextValue = useTextValue();
  const codelist = useCodelist('PRIZE_TYPE');

  return isNullish(value) ||
    !Array.isArray(value) ||
    value.length === 0 ? null : (
    <FlexBox>
      {(value as PrizeWinner[]).map((v, i) => {
        if (v.type === CodeListRef.PRIZE_TYPE.None) {
          const winner = new Builder(v.year).add(
            ', ',
            t('form.global.field.noWinnerThisYear.label'),
          ).value;
          return (
            <FlexBox horizontal key={i} gap={0.5}>
              <TextValue>{winner}</TextValue>
            </FlexBox>
          );
        }

        const typeLabel = codelist.codes.find(c => c.code === v.type)?.value;
        const agentLink = v.agent.link;
        const workLink = v.work?.link;
        const winner = new Builder(v.year)
          .add(', ', typeLabel)
          .add('', ': ').value;
        return (
          <FlexBox horizontal key={i} gap={0.5}>
            <TextValue>{winner}</TextValue>
            <PreviewLinkedEntity value={agentLink} />
            {workLink ? (
              <>
                <TextValue>{' for '}</TextValue>
                <PreviewLinkedEntity value={workLink} />
              </>
            ) : null}
          </FlexBox>
        );
      })}
    </FlexBox>
  );
};
